import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthSessionService } from './auth-session.service';

export const validSessionGuard: CanActivateFn = () => {
  const authSession = inject(AuthSessionService);
  const router = inject(Router);
  const validation = authSession.validate();

  if (!validation) {
    authSession.clear();
    return router.parseUrl('/login');
  }

  return validation.pipe(
    map(() => {
      // Only pax types 1 (VIP), 2 (GSCS) and 3 (EDA) may view the site.
      if (!authSession.paxVersion()) {
        authSession.clear();
        return router.parseUrl('/login');
      }
      return true;
    }),
    catchError(() => {
      authSession.clear();
      return of(router.parseUrl('/login'));
    }),
  );
};
